exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrapper[data-v-666bf39c] {\n  position: relative;\n}\n.full-height[data-v-666bf39c] {\n  height: 100%;\n  overflow-y: scroll;\n}\n.full-height[data-v-666bf39c]::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n  visibility: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-666bf39c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ui/WYSIWYGAndPlainTextEditer.vue
// module id = WBif
// module chunks = 0